import React from 'react'
import { useRecoilState } from 'recoil'
import { MetricsLogoff, PortalLogout } from '@/domain/usecases'
import { DateAdapter } from '@/data/protocols'
import { ADMIN_CODE, useAuth, useTheme } from '@/presentation/hooks'
import { Box, Button, ModalBase, Text, isOpenLogoutState } from '@/presentation/components'
import { styles } from './styles'
import { version } from '../../../../package.json'

type LogoutProps = {
  portalLogout: PortalLogout
  metricsLogoff: MetricsLogoff
  dateAdapter: DateAdapter
}

export const Logout: React.FC<LogoutProps> = ({
  portalLogout,
  metricsLogoff,
  dateAdapter
}) => {
  const theme = useTheme()
  const { logout, getClient, getCurrentClient } = useAuth()
  const [isOpen, setOpen] = useRecoilState(isOpenLogoutState)

  const client = getClient()

  const handleLogout = (): void => {
    const codClient = getCurrentClient()
    logout()
    if (codClient !== ADMIN_CODE.toString()) {
      void portalLogout
        .logout({ cliente: parseInt(codClient), version })
        .catch(console.error)
      void metricsLogoff
        .register({
          dataOcorrencia: dateAdapter.format(dateAdapter.today(), 'YYYY-MM-DDTHH:mm:ssZ'),
          email: client.email,
          unidade: client.unidade,
          usuario: client.codCliente.toString(),
          versao: version
        })
        .catch(console.error)
    }
    setOpen(false)
  }

  const handleClose = (): void => setOpen(false)

  return (
    <ModalBase visible={isOpen} onClose={handleClose}>
      <Box style={styles.container}>
        <Text variant="subtitle1">Tem certeza que deseja sair?</Text>

        <Box style={styles.buttonArea}>
          <Button
            color={theme.colors.shadow}
            tintColor={theme.colors.white}
            variant="text"
            title="CANCELAR"
            onPress={handleClose}
          />
          <Button
            title="SAIR"
            onPress={handleLogout}
            tintColor={theme.colors.white}
            color={theme.colors.success}
          />
        </Box>
      </Box>
    </ModalBase>
  )
}
